import { startCase } from 'lodash';
import * as yup from 'yup';

export interface ICategory {
  id: number;
  name: string;
  cover_image: any;
  parent_id: number;
  heading: string;
  status: string;
  child_categories: Array<ICategory>;
  curated_articles_count: string;
  desires_count: string;
  reviews_count: string;
}

export interface ITableColumn {
  id: keyof ICategory;
  label: string;
  minWidth?: number;
  width?: number;
  align?: 'right' | 'left' | 'center';
  format?: (value: number | string) => string;
  sortable?: boolean;
}

export type IOrder = 'asc' | 'desc';

export const tableColumns: Array<ITableColumn> = [
  {
    id: 'name',
    label: 'Category Name',
    width: 400,
    align: 'left',
    sortable: true,
  },
  {
    id: 'curated_articles_count',
    label: 'Content Code',
    minWidth: 100,
  },
  {
    id: 'desires_count',
    label: 'Product Count',
    minWidth: 100,
  },
  {
    id: 'status',
    label: 'Status',
    minWidth: 100,
    format: (value) => startCase(String(value)),
    sortable: true,
  },
];

export const minimalTableColumns: Array<ITableColumn> = [
  {
    id: 'name',
    label: 'Category Name',
    width: 400,
    align: 'left',
    sortable: true,
  },
  {
    id: 'status',
    label: 'Status',
    minWidth: 100,
    format: (value) => startCase(String(value)),
    sortable: true,
  },
];

function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  if (b[orderBy] < a[orderBy]) return -1;
  if (b[orderBy] > a[orderBy]) return 1;
  return 0;
}

export function getComparator(
  orderBy: any,
  order: IOrder
): (a: any, b: any) => number {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

export const registrationSchema = yup.object().shape({
  name: yup.string().required('Name is a required field'),
  heading: yup.string(),
  status: yup.string(),
});

export const initialValues = {
  name: '',
  heading: '',
  status: 'draft',
};

export const getFlatCategoriesList = (
  arr: Array<ICategory>
): Array<ICategory> => {
  const output = [] as Array<ICategory>;

  arr.forEach((entry) => {
    output.push(entry);
    if (entry.child_categories.length > 0) {
      output.push(...getFlatCategoriesList(entry.child_categories));
    }
  });

  return output;
};

export interface CommonProps {
  layer?: number;
  order?: IOrder;
  isMinimal?: boolean;
  orderBy?: keyof ICategory;
  selector?: {
    currentCategoryId?: number | null;
    selectedId: number | null;
    onSelect?: (id: number | null) => void;
  }
  handlers?: {
    onSortChange?: (orderBy: keyof ICategory, order: IOrder) => void;
    onEdit?: (category: ICategory) => void;
    onPublish?: (categoryId: number, status?: string) => void;
  };
}
